import {
  Glass,
  Dot,
  ScreenLabel,
  DisplayText,
  BodyText,
  alpha,
  borderAlpha,
} from "../../components/mobile/primitives";

function JourneyHomeWithTrackerScreen() {
  return (
    <div style={{ padding: "8px 16px 0", display: "flex", flexDirection: "column", gap: 10 }}>
      {/* Greeting */}
      <div style={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <ScreenLabel>Sun, Mar 2</ScreenLabel>
        <DisplayText size={24}>Good morning</DisplayText>
        <DisplayText size={17} color="#3A4A3D">
          Sverre
        </DisplayText>
      </div>

      {/* Featured Insight */}
      <Glass
        style={{
          padding: "10px 12px",
          background: "linear-gradient(150deg, rgba(165,144,255,0.10), rgba(255,255,255,0.50))",
          border: "1px solid rgba(165,144,255,0.20)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 4, marginBottom: 4 }}>
          <Dot color="var(--color-kin-lavender)" size={5} />
          <ScreenLabel>
            <span style={{ color: "var(--color-kin-lavender)" }}>Sleep Deep Dive</span>
          </ScreenLabel>
        </div>
        <BodyText size={9.5} weight={600}>
          Recovery trending up +15 points
        </BodyText>
        <BodyText size={8} color="var(--color-kin-muted)" weight={400} style={{ marginTop: 1 }}>
          Updated 2h ago
        </BodyText>
      </Glass>

      {/* Immediate action — provenance from skill */}
      <div
        style={{
          background: "rgba(255,208,40,0.10)",
          border: "1px solid rgba(255,208,40,0.28)",
          borderRadius: 16,
          padding: "10px 12px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div
            style={{
              width: 28,
              height: 28,
              borderRadius: 9,
              background: "rgba(255,208,40,0.16)",
              border: "1px solid rgba(255,208,40,0.32)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Dot color="var(--color-kin-gold)" size={8} />
          </div>
          <div style={{ flex: 1 }}>
            <BodyText size={10} weight={700}>
              Log breakfast now
            </BodyText>
            <BodyText size={8.5} color="var(--color-kin-muted)" weight={500}>
              Day 1 of 7 — your energy experiment
            </BodyText>
          </div>
          <div
            style={{
              background: "var(--color-kin-gold)",
              borderRadius: 20,
              padding: "5px 11px",
              flexShrink: 0,
            }}
          >
            <BodyText size={8} color="var(--color-kin-black)" weight={700}>
              Log
            </BodyText>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 5,
            marginTop: 6,
            paddingLeft: 38,
          }}
        >
          <Dot color="var(--color-kin-lavender)" size={4} />
          <BodyText size={7.5} color="var(--color-kin-lavender)" weight={600}>
            Recommended by Sleep Deep Dive
          </BodyText>
        </div>
      </div>

      {/* Trackers — now includes Diet */}
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 7,
          }}
        >
          <ScreenLabel>Today's Trackers</ScreenLabel>
        </div>
        <Glass style={{ padding: "0 12px" }}>
          {[
            {
              color: "var(--color-kin-gold)",
              label: "Diet + Caffeine",
              detail: "Meal timing log",
              status: "Log",
              isNew: true,
            },
            {
              color: "var(--color-kin-lavender)",
              label: "Mood",
              detail: "Daily check-in",
              status: "Log",
              isNew: false,
            },
            {
              color: "var(--color-kin-rose)",
              label: "Headache",
              detail: "Symptom log",
              status: "1 episode",
              isNew: false,
            },
          ].map((t, i) => (
            <div
              key={t.label}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 9,
                padding: "8px 0",
                borderBottom: i < 2 ? "1px solid rgba(0,0,0,0.06)" : "none",
              }}
            >
              <Dot color={t.color} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                  <BodyText size={10} weight={700}>
                    {t.label}
                  </BodyText>
                  {t.isNew && (
                    <span
                      style={{
                        fontSize: 7,
                        fontWeight: 700,
                        color: "var(--color-kin-green-soft)",
                        background: "rgba(91,122,102,0.12)",
                        padding: "1px 5px",
                        borderRadius: 6,
                        fontFamily: "'Manrope', system-ui",
                        textTransform: "uppercase",
                        letterSpacing: "0.06em",
                      }}
                    >
                      New
                    </span>
                  )}
                </div>
                <BodyText size={8} color="var(--color-kin-muted)" weight={500}>
                  {t.detail}
                </BodyText>
              </div>
              <div
                style={{
                  background: t.status === "Log" ? "var(--color-kin-black)" : alpha(t.color, "1A"),
                  border:
                    t.status === "Log"
                      ? "1px solid var(--color-kin-black)"
                      : borderAlpha(t.color, "40"),
                  borderRadius: 20,
                  padding: "4px 12px",
                  cursor: "pointer",
                }}
              >
                <BodyText size={8} color={t.status === "Log" ? "#fff" : t.color} weight={700}>
                  {t.status}
                </BodyText>
              </div>
            </div>
          ))}
        </Glass>
      </div>
    </div>
  );
}

export { JourneyHomeWithTrackerScreen };
